import { useTheme, Box } from '@mui/material';
import { BpmSelectorProps } from './types';
import BpmRange from './BpmRange';
import BpmSelector from './BpmSelector';

const BpmSelectorContainer = ({ onChange, value }: BpmSelectorProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
      }}
    >
      <BpmSelector value={value} onChange={onChange} />
      <BpmRange />
    </Box>
  );
};

export default BpmSelectorContainer;
